import { z } from "zod";

export const passwordResetSchema = z
  .object({
    email: z.string().optional(),
    password: z.string().optional(),
    newPassword: z.string(),
    confirmNewPassword: z.string(),
    agreeTerms: z.boolean(),
    agreePrivacy: z.boolean(),
  })
  .superRefine((data, ctx) => {
    const lengthValid =
      data.newPassword.length >= 8 && data.newPassword.length <= 16;
    const charsetValid =
      /[a-zA-Z]/.test(data.newPassword) && /[0-9]/.test(data.newPassword);

    if (!lengthValid && !charsetValid) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["newPassword"],
        message: "8자 이상 16자 이하, 영문과 숫자를 조합해 주세요.",
      });
    } else if (!lengthValid) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["newPassword"],
        message: "8자 이상 16자 이하로 입력해 주세요.",
      });
    } else if (!charsetValid) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["newPassword"],
        message: "영문과 숫자를 모두 포함해 주세요.",
      });
    } else if (data.password && data.newPassword === data.password) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["newPassword"],
        message: "임시 비밀번호와 다른 비밀번호를 사용해 주세요.",
      });
    }

    if (data.newPassword !== data.confirmNewPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["confirmNewPassword"],
        message: "비밀번호가 일치하지 않습니다.",
      });
    }
  });
